import QuantityControl from "../general/QuantityControl";
import type Addons from "./addons/Addons";
import type Summary from "./Summary";
import type { ILineItem } from "./Summary";

export interface IUpdating {
	onChange: (items: Array<ILineItem>) => void;
}

export default class ProductPage {
	private addons?: Addons;
	private addToCartButton: HTMLButtonElement;
	private readonly baseCost: number;
	private boxQuantity: number;
	private errorDiv: HTMLDivElement;
	private innerQuantity: number;
	private internalQuantityInput: HTMLInputElement;
	private priceDiv: HTMLDivElement;
	private quantityControl?: QuantityControl;
	private summary?: Summary;

	constructor() {
		this.innerQuantity = 1;
		this.boxQuantity = 1;
		this.baseCost = ProductPage.getBaseCostFromPage();
		const quantityControlElements = Array.from(
			document.querySelectorAll(QuantityControl.outerSelector),
		).filter((e) => e instanceof HTMLDivElement);
		for (const quantityControl of quantityControlElements) {
			this.quantityControl = new QuantityControl(quantityControl, (e) => {
				this.onQuantityChange(e);
			});
		}

		if (document.querySelector(".exto-product-summary")) {
			import("./Summary").then((e) => (this.summary = new e.default()));
		}

		if (document.querySelector("#exto-mobile-featured")) {
			import("./Gallery").then((e) => new e.default());
		}

		if (document.querySelector(".exto-addon")) {
			import("./addons/Addons").then(
				(e) =>
					(this.addons = new e.default(() => {
						this.onChange();
					})),
			);
		}

		this.priceDiv = document.querySelector(
			"#exto-final-price bdi",
		) as HTMLDivElement;

		this.errorDiv = document.querySelector(
			".exto-error-message",
		) as HTMLDivElement;

		this.addToCartButton = document.querySelector(
			".exto-add-to-cart-btn button",
		) as HTMLButtonElement;

		this.internalQuantityInput = document.querySelector(
			'input[name="quantity"]',
		) as HTMLInputElement;
	}

	private static getBaseCostFromPage() {
		const element = document.querySelector(".extendo") as HTMLElement;
		const { basecost } = element.dataset;
		if (!basecost) {
			throw new Error("Base cost not supplied");
		}
		const price = Number.parseFloat(basecost);
		if (!price) {
			throw new Error("Page missing required pricing data");
		}
		return price;
	}

	onChange() {
		let isValidConfiguration = true;
		if (this.quantityControl) {
			this.innerQuantity = this.quantityControl.getInnerQuantity();
			this.boxQuantity = this.quantityControl.getBoxQuantity();
		}

		let price = this.baseCost * this.boxQuantity;
		this.summary?.removeAllLineItems();

		const validateAddons = () => {
			if (!this.addons) return;
			for (const addon of this.addons.getAddons()) {
				for (const lineItem of addon.getLineItems()) {
					const quantityAdjustedItem = { ...lineItem };
					let { value } = quantityAdjustedItem;
					value *= this.innerQuantity;
					quantityAdjustedItem.value = value;
					price += value;
					this.summary?.addLineItem(quantityAdjustedItem);
				}
				if (!addon.isValid()) {
					isValidConfiguration = false;
					this.errorDiv.textContent = addon.errorMessage();
				}
			}
		};

		if (this.addons) {
			validateAddons();
		}
		if (isValidConfiguration) {
			this.errorDiv.style.display = "none";
			this.errorDiv.textContent = "";
		} else {
			this.errorDiv.style.display = "flex";
		}
		this.priceDiv.textContent = "$" + Number(price).toFixed(2);
		this.addToCartButton.disabled = !isValidConfiguration;
	}

	/** @param e */
	private onQuantityChange(e: number) {
		this.internalQuantityInput.value = String(e);
		this.onChange();
	}
}
